//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Paging from '@/frontend/components/common/paging'

export default {
  name: 'ProductList',
  components: {
    Paging,
  },
  props: {
    section: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      products: [],
      productListLoading: false,
      metalOptions: [
        {checked: false, label: 'Sterling Silver', value: 'SLV'},
        {checked: false, label: 'White Gold', value: 'KW'},
        {checked: false, label: 'Yellow Gold', value: 'KY'},
        {checked: false, label: 'Rose Gold', value: 'KR'},
      ],
      stonesOptions: [
        {checked: false, label: '1', value: '1'},
        {checked: false, label: '2', value: '2'},
        {checked: false, label: '3', value: '3'},
        {checked: false, label: '4', value: '4'},
        {checked: false, label: '5', value: '5'},
        {checked: false, label: '6', value: '6'},
        {checked: false, label: '7', value: '7'},
        {checked: false, label: '8', value: '8'},
        {checked: false, label: '9', value: '9'},
        {checked: false, label: '10', value: '10'},
        {checked: false, label: '11', value: '11'},
        {checked: false, label: '12', value: '12'},
        {checked: false, label: '13', value: '13'},
        {checked: false, label: '14', value: '14'},
        {checked: false, label: '15', value: '15'},
      ],
      typeOptions: [
        {checked: false, label: 'Rings', value: '1'},
        {checked: false, label: 'Necklaces', value: '2'},
        {checked: false, label: 'Bracelets', value: '3'},
      ],
      noBirthstonesGroups: ['PALPHOTO','PALNAME','RING_NF','EARRING_NF','PENDANT_NF','BRACELET_NF'],
    }
  },
  computed: {
    selectedMetalFilter() {
      return this.metalOptions.find((option) => option.checked)
    },
    selectedStoneFilter() {
      return this.stonesOptions.find((option) => option.checked)
    },
    selectedTypeFilter() {
      return this.typeOptions.find((option) => option.checked)
    },
  },
  async mounted() {
    this.setDefaultType()
    this.reloadProductList()
  },
  methods: {
    setDefaultType() {
      const currentCategory = this.$route.path.split('/').pop()
      this.typeOptions.forEach((type) => {
        if (currentCategory.toLowerCase() === type.label.toLowerCase()) {
          type.checked = true
        }
      })
    },
    async reloadProductList(pager = null) {
      this.products = []
      this.productListLoading = true
      await this.$nuxt.$nextTick(async () => {
        await this.$axios
          .$get(
            '/ProductCategories/RetailProducts/' +
              this.$route.path.split('/').pop() +
              this.buildQueryString(pager)
          )
          .then((products) => {
            this.products = products
            this.productListLoading = false
          })
      })
    },
    async resetAndReloadProductList() {
      this.page = 1
      await this.reloadProductList()
    },
    buildQueryString(pager) {
      let queryString = ``

      if (pager) {
        queryString = `?PageSize=${pager.pageSize.value}&PageNo=${pager.pageNumber}`
        // if (pager.sortBy) {
        //   queryString = queryString.concat(`&SortBy=${pager.sortBy.value}`)
        // }
      } else {
        queryString = `?PageSize=${16}&PageNo=${1}`
      }

      if (this.selectedMetalFilter) {
        queryString = queryString.concat(
          `&Metal=${this.selectedMetalFilter.value}`
        )
      }
      if (this.selectedStoneFilter) {
        queryString = queryString.concat(
          `&StoneNo=${this.selectedStoneFilter.value}`
        )
      }
      const currentCategory = this.$route.path.split('/').pop()
      if (currentCategory === 'new-pieces' && this.selectedTypeFilter) {
        queryString = queryString.concat(
          `&Type=${this.selectedTypeFilter.label.toLowerCase()}`
        )
      }
      return queryString
    },
    resetStones() {
      this.stonesOptions.forEach((option) => {
        option.checked = false
      })
    },
    resetMetal() {
      this.metalOptions.forEach((option) => {
        option.checked = false
      })
    },
    async resetStonesFilter() {
      this.resetStones()
      await this.reloadProductList()
    },
    async resetMetalFilter() {
      this.resetMetal()
      await this.reloadProductList()
    },
    async resetTypeFilter() {
      const currentCategory = this.$route.path.split('/').pop()
      if (currentCategory === 'new-pieces') {
        this.typeOptions.forEach((option) => {
          option.checked = false
        })
        await this.reloadProductList()
      }
    },
    pagerChanged(pager) {
      if (pager) {
        this.reloadProductList(pager)
        this.$refs.collectionPagerTop.setupPagingInfo(pager)
        this.$refs.collectionPagerBottom.setupPagingInfo(pager)
      }
    },
    resetFilters() {
      this.resetStones()
      this.resetMetal()
      this.resetTypeFilter()
    },
  },
}
